"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _FilterControls = _interopRequireDefault(require("../FilterControls/FilterControls"));

var _Header = _interopRequireDefault(require("./Header.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _propTypes2 = require("../propTypes");

/* eslint jsx-a11y/no-noninteractive-element-interactions: 0 */
function HeaderRow(_ref) {
  var theme = _ref.theme,
      columns = _ref.columns,
      sortState = _ref.sortState,
      filterState = _ref.filterState,
      sortTable = _ref.sortTable,
      filterTable = _ref.filterTable,
      headerBordered = _ref.headerBordered,
      fixedHeader = _ref.fixedHeader,
      top = _ref.top;
  return _react.default.createElement("tr", null, columns.map(function (col) {
    var sortedByCol = col.key === sortState.key;
    var colFiltersApplied = filterState[col.key] || col.selectedFilters || [];
    return _react.default.createElement("td", {
      className: (0, _classnames.default)((0, _Header.default)(theme, col.sorter || col.sortFn, sortedByCol, colFiltersApplied.length, sortState.reverse, headerBordered), col.className),
      style: col.cellStyle,
      key: col.key,
      rowSpan: col.rowSpan || 1,
      colSpan: col.colSpan || 1,
      onClick: function onClick() {
        return (col.sorter || col.sortFn) && sortTable(col.key, sortedByCol && !sortState.reverse);
      }
    }, (0, _isFunction.default)(col.title) ? col.title() : col.title, _react.default.createElement(_FilterControls.default, {
      filters: col.filters,
      filterSingle: col.filterSingle,
      columnKey: col.key,
      filterTable: filterTable,
      colFiltersApplied: colFiltersApplied,
      filterDropdown: col.filterDropdown,
      filterDropdownVisible: col.filterDropdownVisible,
      popupOnRight: col.popupOnRight,
      filterIconName: col.filterIconName,
      onFilterDropdownVisibleChange: col.onFilterDropdownVisibleChange,
      fixedHeader: fixedHeader,
      top: top
    }), (col.sorter || col.sortFn) && _react.default.createElement(_Icon.default, {
      type: "angle-down"
    }));
  }));
}

HeaderRow.propTypes = {
  theme: _propTypes.default.shape({}).isRequired,
  sortTable: _propTypes.default.func.isRequired,
  sortState: _propTypes.default.shape({
    key: _propTypes.default.string,
    reverse: _propTypes.default.bool
  }).isRequired,
  filterTable: _propTypes.default.func.isRequired,
  filterState: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.string)).isRequired,
  columns: _propTypes.default.arrayOf(_propTypes2.columnPropType).isRequired,
  headerBordered: _propTypes.default.bool.isRequired,
  fixedHeader: _propTypes.default.bool,
  top: _propTypes.default.string
};

var _default = (0, _emotionTheming.withTheme)(HeaderRow);

exports.default = _default;